import MovementsTable from './MovementsTable'

export default MovementsTable
